import { apiGet } from '@/store/api';

export async function getVessel(vesselID: string | number) {
  return apiGet(`vessel/${vesselID}`);
}
